module.exports = __webpack_public_path__ + "media/videos/testimonials/jessica-alba-h265-9611f549c2e177832dce79747c6bf238.mp4";